'use client';

import styled, { TColorProp } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

export type TLabelSize = 'x-large' | 'large' | 'medium' | 'small' | 'x-small';

interface IContainerProps {
  $size: TLabelSize;
  $color: TColorProp;
}

const getLineHeight = {
  'x-large': 32,
  large: 24,
  medium: 24,
  small: 20,
  'x-small': 16,
} as Record<TLabelSize, number>;

const getFontSize = {
  'x-large': 24,
  large: 18,
  medium: 16,
  small: 14,
  'x-small': 12,
} as Record<TLabelSize, number>;

const getLetterSpacing = (size: TLabelSize): number => {
  const fontSize = getFontSize[size];
  const percentage = (
    {
      'x-large': -1.5,
      large: -1.5,
      medium: -1.1,
      small: -0.6,
      'x-small': 0,
    } as Record<TLabelSize, number>
  )[size];

  return (fontSize * percentage) / 100;
};

export const Container = styled.span<IContainerProps>`
  line-height: ${({ $size }) => getLineHeight[$size]}px;
  font-size: ${({ $size }) => getFontSize[$size]}px;
  letter-spacing: ${({ $size }) => getLetterSpacing($size)}px;
  font-weight: 500;
  color: ${({ theme, $color }) => getThemeColor(theme, $color)};
`;
